import * as v from "valibot";

// request schema
export const RequestSchema = v.object({
  ClusterId: v.string(),
  Page: v.optional(v.pipe(v.number(), v.integer())),
  PageSize: v.optional(v.pipe(v.number(), v.integer())),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response schema
export const SpecBeforeSchema = v.object({
  APIServerMemory: v.string(),
  ETCDNum: v.number(),
});
export type SpecBefore = v.InferOutput<typeof SpecBeforeSchema>;

export const SpecAfterSchema = v.object({
  APIServerMemory: v.string(),
  ETCDNum: v.number(),
});
export type SpecAfter = v.InferOutput<typeof SpecAfterSchema>;

export const ScaleRecordSchema = v.object({
  clusterId: v.string(),
  endTime: v.nullish(v.string()),
  instanceId: v.string(),
  scaleStatus: v.string(),
  scaleType: v.string(),
  specAfter: SpecAfterSchema,
  specBefore: SpecBeforeSchema,
  startTime: v.string(),
});
export type ScaleRecord = v.InferOutput<typeof ScaleRecordSchema>;

export const DataSchema = v.object({
  Marker: v.number(),
  Page: v.number(),
  PageSize: v.number(),
  ScaleRecords: v.nullish(v.array(ScaleRecordSchema)),
  TotalCount: v.number(),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
